import { render, staticRenderFns } from "./AdminColorsScreen.vue?vue&type=template&id=431b6ae0&scoped=true&"
import script from "./AdminColorsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminColorsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b6ae0",
  null
  
)

export default component.exports